export const login = {
    label: "تسجيل الدخول",
    href: "#",
    target: "internal",
};

export const more = {
    label: "أكثر",
    href: "#",
    target: "internal",
};
